import { memo } from "react";
import { useTranslation } from "react-i18next";

import { Label } from "../../../../../../components/Fonts";
import { PlusTag } from "../../../../../../components/PlusTag";
import { AlignOptionContainer, AlignOptionsContainer, Container } from "./styles";

const AlignIcon = () => {
  return (
    <>
      <span></span>
      <span></span>
      <span></span>
    </>
  );
};

const AlignIconMemoized = memo(AlignIcon);

type Props = {
  value: string;
  onSelect: (value: Align) => void;
  /** PLUS only: shown with the PLUS tag, and any click asks to subscribe (`onLocked`) instead. */
  locked?: boolean;
  onLocked?: () => void;
};

const prefix = "pages.editor.settings.form.advancedCustomization.inputs.aligment";

type Align = "LEFT" | "CENTER" | "RIGHT";

/** The options, each with its name's key: left, center, right. */
const ALIGNS: [Align, string][] = [
  ["LEFT", "left"],
  ["CENTER", "center"],
  ["RIGHT", "right"],
];

export const AlignSection = ({ value, onSelect, locked, onLocked }: Props) => {
  const { t } = useTranslation();
  const select = (align: Align) => (locked ? onLocked?.() : onSelect(align));

  return (
    <Container $locked={locked}>
      <span className="title">
        <Label>{t(`${prefix}.label`)}</Label>
        {locked && (
          <button type="button" className="plus" onClick={onLocked}>
            <PlusTag />
          </button>
        )}
      </span>
      <AlignOptionsContainer role="radiogroup" aria-label={t(`${prefix}.label`)}>
        {ALIGNS.map(([align, key]) => (
          <AlignOptionContainer
            key={align}
            type="button"
            role="radio"
            aria-checked={value === align}
            aria-label={t(`${prefix}.${key}`)}
            $active={value === align}
            $align={align}
            onClick={() => select(align)}>
            <AlignIconMemoized />
          </AlignOptionContainer>
        ))}
      </AlignOptionsContainer>
    </Container>
  );
};
